import React, { useCallback } from 'react';

import { ButtonSizes } from '@rbilabs/components-library';
import { useNavigate } from 'react-router';

import { ActionButton } from 'components/action-button';
import { useLoyaltyOffersEmptyStates } from 'hooks/use-loyalty-offers-empty-states';

import {
  EmptyState,
  EmptyStateDescription,
  EmptyStateImage,
  EmptyStateTitle,
} from './offers-empty-state.styled';

export const OffersEmptyState = () => {
  const { offersEmptyStates, offersEmptyStatesLoading } = useLoyaltyOffersEmptyStates();
  const navigate = useNavigate();

  const handleClick = useCallback((link: string) => {
    navigate(link);
  }, []);

  if (offersEmptyStatesLoading || !offersEmptyStates) {
    return null;
  }

  return (
    <EmptyState>
      <EmptyStateImage
        image={offersEmptyStates.emptyStateOffersImage?.locale}
        alt=""
        objectFitContain
      />
      <EmptyStateTitle data-testid="offers-empty-state-title">
        {offersEmptyStates.emptyStateOffersTitle?.locale}
      </EmptyStateTitle>
      <EmptyStateDescription data-testid="offers-empty-state-description">
        {offersEmptyStates.emptyStateOffersDescription?.locale}
      </EmptyStateDescription>
      {offersEmptyStates.ctaButtonLink?.locale && (
        <ActionButton
          onClick={() => handleClick(offersEmptyStates.ctaButtonLink?.locale as string)}
          size={ButtonSizes.LARGE}
        >
          {offersEmptyStates.ctaButtonText?.locale}
        </ActionButton>
      )}
    </EmptyState>
  );
};
